angular
	.module 'App.Component'
	.component 'secretInput',
		{
			templateUrl: '@component/input/secret-input/secret-input.view.html'
			controller: 'SecretInputController'
			controllerAs: 'input'
			require:
				ngModelController: 'ngModel'
			bindings:
				id: '<?'
				label: '@'
				isSet: '<?'
				infoTooltip: '@?'
				errorTooltip: '@?'
				isDisabled: '<?'
				isRequired: '<?'
		}

class SecretInputController extends AbstractController
	@register()
	@inject '$scope',
		'$element'
		'$attrs'
		'parseBool'

	initialize: ->
		@isSecretChangeEnabled = false

		@id ?= "secret-input-#{@controllerId}"
		@isSet ?= false
		@isSet = @parseBool(@isSet)
		@errorTooltip ?= "'@component/input/secret-input/secret-input.tooltip.view.html'"

		@MessageTerminal.on @$scope, @MessageTerminal.events.CRUD.UPDATE, => @disableSecretChange()
		@MessageTerminal.on @$scope, @MessageTerminal.events.CRUD.ADD, => @disableSecretChange()

		@ngModelController.$render = =>
			@model = @ngModelController.$viewValue

		@ngModelController.$validators.required = (value) =>
			if @isRequired && (!@isSet || @isSecretChangeEnabled)
				return value? && !@ngModelController.$isEmpty(value)

			return true

	$onChanges: (changes) ->
		if changes.isRequired?
			@isRequired = @parseBool(changes.isRequired.currentValue)

		if changes.isDisabled?
			@isDisabled = @parseBool(changes.isDisabled.currentValue)

	toggleSecretChange: ->
		@isSecretChangeEnabled = !@isSecretChangeEnabled
		@model = null

	disableSecretChange: ->
		@isSecretChangeEnabled = false
		@model = null

	hasDisplayableErrors: ->
		errorCount = Object.keys(@ngModelController.$error).length
		hasRequiredError = @ngModelController.$error.hasOwnProperty('required')

		return errorCount > 1 || errorCount > 0 && !hasRequiredError

	onModelChange: ->
		@ngModelController.$setViewValue(@model)
